let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("5xy7Q")).then(() => parcelRequire('heDdi'));